import React from 'react';
import UniversalCard from '../../../shared/UniversalCard';
import './NextPaymentCard2.scss';
import MockDataWrapper from '../../../shared/MockDataWrapper';

interface NextPaymentData {
  id: string;
  amount: number;
  dueDate: string;
  unitNumber: string;
  address: string;
}

interface NextPaymentCard2Props {
  data?: NextPaymentData[];
  className?: string;
}

// Моковые данные по умолчанию
const mockPaymentData: NextPaymentData[] = [
  {
    id: '1',
    amount: 1450,
    dueDate: '2025-05-16',
    unitNumber: '184',
    address: '314 Rue de Montceau, Laval, QC H7N 1E9, Canada',
  },
  {
    id: '2',
    amount: 1650,
    dueDate: '2025-06-15',
    unitNumber: '205',
    address: '1250 Boulevard Laval, Laval, QC H7S 2L2, Canada',
  },
  {
    id: '3',
    amount: 1200,
    dueDate: '2025-05-30',
    unitNumber: '97',
    address: '892 Rue Saint-Martin, Laval, QC H7M 1Y8, Canada',
  },
];

// Иконка доллара
const dollarIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Функция рендера содержимого платежной карточки
const renderPaymentContent = (item: any) => {
  const payment = item as NextPaymentData;
  const formatAmount = (amount: number) => `${amount.toLocaleString()}`;

  return (
    <>
      <div className="NextPaymentCard2__amount">
        {formatAmount(payment.amount)}
      </div>

      <div className="NextPaymentCard2__details">
        {/* Due date */}
        <div className="NextPaymentCard2__detail">
          <div className="NextPaymentCard2__detail-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.6667 2.66669H3.33333C2.59695 2.66669 2 3.26364 2 4.00002V12C2 12.7364 2.59695 13.3334 3.33333 13.3334H12.6667C13.403 13.3334 14 12.7364 14 12V4.00002C14 3.26364 13.403 2.66669 12.6667 2.66669Z"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.6667 1.33331V3.99998M5.33333 1.33331V3.99998M2 6.66665H14"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="NextPaymentCard2__detail-label">Due date:</span>
          <span className="NextPaymentCard2__detail-value">
            {payment.dueDate}
          </span>
        </div>

        {/* Unit */}
        <div className="NextPaymentCard2__detail">
          <div className="NextPaymentCard2__detail-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="8" cy="8" r="7" stroke="#105E96" />
              <path
                d="M8 11.5v-3.5M8 4.5h.01"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="NextPaymentCard2__detail-label">Unit:</span>
          <span className="NextPaymentCard2__detail-value">
            {payment.unitNumber}
          </span>
        </div>

        {/* Address */}
        <div className="NextPaymentCard2__detail NextPaymentCard2__detail--address">
          <div className="NextPaymentCard2__detail-icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 6.5C13 10.09 8 14 8 14C8 14 3 10.09 3 6.5C3 4.01 5.49 2 8 2C10.51 2 13 4.01 13 6.5Z"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle
                cx="8"
                cy="6.5"
                r="1.5"
                stroke="#105E96"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="NextPaymentCard2__detail-text">
            {payment.address}
          </span>
        </div>
      </div>
    </>
  );
};

const NextPaymentCard2: React.FC<NextPaymentCard2Props> = ({
                                                             data,
                                                             className = '',
                                                           }) => {
  // Определяем, используются ли мок-данные
  //const isMockData = !data;
  const displayData = data || mockPaymentData;

  return (

      <UniversalCard
        title="Next Payment"
        backgroundColor="#76C102"
        icon={dollarIcon}
        data={displayData}
        renderContent={renderPaymentContent}
        className={className}
      />

  );
};

export default NextPaymentCard2;